import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { useEffect } from "react";
import { apiRequest } from "../apiService/allApi";
const axios = require("axios");

const firebaseConfig = {
  apiKey: "AIzaSyAh43nftHQ5U6_ccpJZQ0ktIdheaqJIy-w",
  authDomain: "apnaadda-1bea5.firebaseapp.com",
  projectId: "apnaadda-1bea5",
  storageBucket: "apnaadda-1bea5.firebasestorage.app",
  messagingSenderId: "180195144243",
  appId: "1:180195144243:web:91d42d6af27119d8d66946",
  measurementId: "G-K4TJ8RJH17"
};
// BASE URL

const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const nodeMode = process.env.NODE_ENV;
if (nodeMode === "development") {

  var baseUrl = beckendLocalApiUrl;
} else {
  baseUrl = beckendLiveApiUrl;
}
// +++++++++++++++++++++++++++++ 
const access_token = localStorage.getItem("token");
const fcm = localStorage.getItem("fcm");
export const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

const db = getFirestore(app);

export const getTokens = async (setTokenFound) => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BNmMHDhisk8-UEwB1bzvLQ15GFpiymmkf9Ez8vwHZLHMuz3pGG2q_4J-kUqBfzhGAdI7wMpZ1Zzs157XQ6ALRnw",
    });

    if (currentToken) {
      if (access_token && fcm !== currentToken) {
        const headers = {
          Authorization: `Bearer ${access_token}`,
        };
        try {
          // const res = await axios.get(
          //   baseUrl+`updateToken?firebaseToken=${currentToken}`,
          //   { headers }
          // );
          const res = await apiRequest(`updateToken?firebaseToken=${currentToken}`, "GET", null, headers)

          console.log(res);
          localStorage.setItem("fcm", currentToken);
        } catch (e) {
          console.log(e);
        }
      }
      setTokenFound({ status: true, token: currentToken });
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
      setTokenFound(false);
    }
  } catch (err) {
    // console.log(err);
  }
};

// getTokens();
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
      console.log(payload);
    });
  });




